import { MeasurementDateRollover } from 'api';
import { RolloverParams } from 'services/hooks/useRolloverCompanies/rollover.types';
import { MultipleRequestTypes } from './separateIntoMultipleRequests.types';
import { NONE } from '../../constants';

export const separateIntoMultipleRequests = (postData: RolloverParams): MultipleRequestTypes => {
  const fundRequests: MeasurementDateRollover[] = [];
  const companyRequests: MeasurementDateRollover[] = [];

  if (postData.funds && postData.funds.length > 0) {
    postData.funds.forEach(fundId => {
      fundRequests.push({
        new_measurement_date: postData.newMeasurementDate,
        firm_id: postData.firmId,
        fund_ids: [fundId],
      });
    });
  }
  if (postData.rollovers && postData.rollovers.length > 0) {
    postData.rollovers.forEach(rollover => {
      companyRequests.push({
        new_measurement_date: postData.newMeasurementDate,
        firm_id: postData.firmId,
        company_rollovers: [
          {
            company_id: rollover.companyId,
            reset_financials: rollover.resetFinancials,
            exclude_documents: rollover.excludeDocuments,
            exclude_valuations: rollover.excludeValuation,
            keep_market_data: rollover.keepMarketData,
            market_date: rollover.marketDate || undefined, // should be nullable
            source_date: rollover.customDate === NONE || rollover.customDate === null ? undefined : rollover.customDate, // should be nullable
          },
        ],
      });
    });
  }
  return { fundRequests, companyRequests };
};
